<template>
    <div>
        <div class="form-row">
            <div class="col col-12" :class="( etiqueta_layouts && etiqueta_layouts.length ) ? 'col-md-8' : ''">
                <az-input 
                    placeholder="Informe o nome ou CPF do paciente..."
                    icon="fas fa-user"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    ref="info_paciente"
                    v-model="dados.paciente" 
                    :optimized_ac="true"
                    @input="selecionarPaciente()" />
            </div>
            <div class="col col-12 col-md-4" v-if="etiqueta_layouts && etiqueta_layouts.length">
                <az-input
                    icon="fa fa-tags"
                    placeholder="Selecione o Layout..."
                    type="select"
                    :optionsList="etiqueta_layouts"
                    optionsData="id_etiqueta_layout"
                    optionsDisplay="search"
                    v-model="layout" />
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && ( lista && lista.length )"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state v-if="!lista || !lista.length" :msg="!dados.paciente ? 'Selecione o Paciente...' : ''" />

        <!-- Lista de agendas -->
        <div class="mt-3" id="lista-de-trabalho">
            <div class="mb-3 mx-3">
                <div v-for="(items, quebra, iqx) in lista_agrupada" :key="'L' + iqx">
                    <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white">
                        <!-- Ação -->
                        <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                            <template v-if="items.length == 1">
                                <div class="d-flex flex-column" v-if="items[0].status_laudo">
                                    <button class="btn btn-sm" :class="'btn-' + items[0].status_laudo.st_color" :disabled="true">
                                        {{ items[0].status_laudo.search }}
                                    </button>
                                </div>
                            </template>
                        </div>
                        <!-- Data -->
                        <div class="col col-12 col-md-2"> 
                            <div>{{ $util.getFormatDate(items[0].dt_inclusao) }} {{ items[0].dt_inclusao.substr(11,5) }}</div>
                            <div>#{{ items[0].atendimento_procedimento.id_atendimento }}</div>
                        </div>
                        
                        <div class="col col-12 col-md-4 d-flex justify-content-between">
                            <template v-if="items.length == 1">
                                <celula-dados-procedimento :blockanexos="true" :hor="dados_procedimento(items[0])" />
                            </template>
                            <div v-else>
                                <a href="#" @click.prevent="imprimir(item)" v-for="(item, iix) in items" :key="iix">
                                    <span class="badge mr-1" :class="'badge-' + ( item.status_laudo ? item.status_laudo.st_color : 'secondary' )"
                                        data-toggle="tooltip" data-placement="top" :title="item.status_laudo.search">
                                        {{ sigla(item) }}
                                    </span>
                                </a>
                            </div>
                            <!-- @abriranexos="abrir_anexar_arquivo" @abrirpreatend="$refs.doc_pre_atend.abrir" /> -->
                        </div>

                        <!-- Impressão -->
                        <div class="col col-12 col-md-4 text-right">
                            <button type="button" class="btn btn-outline-primary" :disabled="!layout" @click="imprimir_etiqueta(items[0])">
                                <i class="fas fa-tag"></i>
                            </button>
                            <template v-if="items.length == 1">
                                <template v-if="items[0].arquivos && items[0].arquivos.length">
                                    <a :href="arq.arquivo.temporary_url" class="btn ml-1" :class="arq.st_tipo_especial == 'anexo' ? 'btn-outline-secondary' : 'btn-outline-primary'" v-for="(arq, iax) in items[0].arquivos" :key="iax"
                                        target="_blank" title="Imprimir">
                                        <i class="fa fa-paperclip" aria-hidden="true" v-if="arq.st_tipo_especial == 'anexo'"></i>
                                        <i class="fa fa-print" aria-hidden="true" v-else></i>
                                    </a>
                                </template>
                                <template v-if="!(items[0].arquivos && items[0].arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length) && items[0].status_laudo">
                                    <button type="button" class="btn btn-outline-primary ml-1" :disabled="!items[0].status_laudo.fl_pronto" @click="imprimir(items[0])"
                                        title="Imprimir">
                                        <i class="fa fa-print" aria-hidden="true"></i>
                                    </button>
                                </template>
                            </template>
                            <template v-else-if="items.length > 1">
                                <button type="button" class="btn btn-outline-primary ml-1"  
                                    title="Imprimir"
                                    :disabled="!tem_laudo_pronto(items)" @click="imprimir_lab(items[0])">
                                    <i class="fa fa-print" aria-hidden="true"></i>
                                </button>
                            </template>

                            <!-- Entrega de Resultados -->
                            <template v-if="items.length > 0">
                                <button type="button" class="btn ml-1" :class="( items[0].laudo_entregas && items[0].laudo_entregas.length ) ? 'btn-primary'  : 'btn-outline-primary'"
                                    :disabled="items[0].status_laudo && !items[0].status_laudo.fl_pronto" 
                                    @click="registrar_entrega(items[0])"
                                    title="Registrar Entrega">
                                    <i class="fas fa-hand-holding-medical"></i>
                                </button>
                            </template>
                        </div>
                    </div>
                </div>

                <template v-if="false">
                    <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white" v-for="(item, index) in lista"
                        :key="index"
                        >
                        <!-- Ação -->
                        <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                            <div class="d-flex flex-column" v-if="item.status_laudo">
                                <button class="btn btn-sm" :class="'btn-' + item.status_laudo.st_color" :disabled="true">
                                    {{ item.status_laudo.search }}
                                </button>
                            </div>
                        </div>
                        <!-- Data -->
                        <div class="col col-12 col-md-2"> 
                            <div>{{ $util.getFormatDate(item.dt_inclusao) }} {{ item.dt_inclusao.substr(11,5) }}</div>
                            <div>#{{ item.atendimento_procedimento.id_atendimento }}</div>
                        </div>
                        
                        <div class="col col-12 col-md-4 d-flex justify-content-between">
                            <celula-dados-procedimento :hor="dados_procedimento(item)" />
                            <!-- @abriranexos="abrir_anexar_arquivo" @abrirpreatend="$refs.doc_pre_atend.abrir" /> -->
                        </div>

                        <!-- Impressão -->
                        <div class="col col-12 col-md-4 text-right">
                            <button type="button" class="btn btn-outline-primary mr-1" :disabled="!layout" @click="imprimir_etiqueta(item)">
                                <i class="fas fa-tag"></i>
                            </button>
                            <template v-if="item.status_laudo">
                                <button type="button" class="btn btn-outline-primary" :disabled="!item.status_laudo.fl_pronto" @click="imprimir(item)">
                                    <i class="fa fa-print" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="btn btn-outline-primary ml-1" v-if="is_lab(item)" 
                                    :disabled="item.status_laudo && !item.status_laudo.fl_pronto" @click="imprimir_lab(item)">
                                    <i class="fas fa-layer-group"></i>
                                </button>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";

export default {
    data() { 
        return { 
            dados: { 
                paciente: "",
                laudos: [],
            },
            canceltoken: null, 
            etiqueta_layouts: [],
            layout: this.$util.getCookie('etiqueta-layout-entrega'), 
            entrega: null, 
            entregar_para: null, 
            validate: false, 
        };
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        CelulaDadosProcedimento, 
    },

    computed: { 
        lista: function () { 
            return this.dados.laudos;
        },

        lista_agrupada: function () { 
            return _.groupBy(this.lista, (item) => {
                return this.is_lab(item) 
                    ? 'L' + item.atendimento_procedimento.id_atendimento 
                    : item.atendimento_procedimento.id_atendimento_procedimento;
            });
        },
    },

    methods: { 
        is_lab(item) { 
            return item.atendimento_procedimento.procedimento.id_especialidade == 2
                || item.atendimento_procedimento.procedimento.id_especialidade == 67;
        },

        registrar_entrega(item) { 
            this.$refs.entrega.registrar_entrega(item);
        },

        sigla(item) { 
            return item.atendimento_procedimento.procedimento.st_sigla 
                ? item.atendimento_procedimento.procedimento.st_sigla 
                : item.atendimento_procedimento.procedimento.st_procedimento;
        },

        tem_laudo_pronto(lista) { 
            return lista.find(item => item && item.status_laudo && item.status_laudo.fl_pronto) ? true : false;
        },

        imprimir_lab(laudo) { 
            this.$util.print_preview('imprimir/laudo_lab/' + laudo.atendimento_procedimento.id_atendimento, true);
        },

        imprimir(laudo) { 
            if ( laudo.status_laudo && !laudo.status_laudo.fl_pronto ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: laudo.atendimento_procedimento.procedimento.search,
                    detail: "Laudo: " + laudo.status_laudo.search,
                    life: 3000
                });
                return;
            }

            this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true);
        },

        imprimir_etiqueta(laudo) { 
            if ( !this.layout ) { 
                return;
            }

            this.$util.print_preview('imprimir/etiqueta/' + laudo.id_laudo + '/' + this.layout, true);

            this.$util.setCookie('etiqueta-layout-entrega', this.layout);
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao.arquivos,
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends, 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao, 
                }
            };
        },

        selecionarPaciente() { 
            this.entregar_para = "";

            this.$nextTick(() => { 
                this.load();
            });
        },

        load(refresh = false) { 

            if ( !refresh )
                this.dados.laudos = [];

            if ( !this.dados.paciente )
                return;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.$util.load(this, { 
                service: 'laudos',
                func: 'entrega',
                parms: { 
                    id_paciente: this.dados.paciente.id_pessoa, 
                },
                canceltoken: this.canceltoken.token,
                loadTo: res => { 
                    this.dados.laudos = res.laudos;
                }
            });

        }
    },

    mounted() { 

        this.$store.commit("setBreadcrumb", [
            { name: "Assistência", path: "/assistencia/atend" },
            { name: "Planejamento de Infusão", path: "/assistencia/infusao" },
        ]);

    }   
}
</script>